<template>
  <v-layout row :class="$style['currency-field']">
    <div :style="{ width: '100%', display: 'flex' }">
      <ValidationProvider
        v-slot="{ errors }"
        :rules="mergedRules"
        :name="label"
        :vid="name"
        :style="{ display: 'flex', alignItems: 'baseline', width  }"
      >
        <CInput
          class="currency-text-field"
          v-model="localValue"
          type="text"
          filled
          single-line
          :data-vv-as="label"
          :name="name"
          :invalidFeedback="errors[0]"
          :isValid="errors[0] ? false : null"
          :min="min"
          :placeholder="placeholder"
          @focus="focus"
          @blur="(e) => (localValue = formatCurrency(e.target.value))"
          style="width: 100%;"
        />
      </ValidationProvider>
      <span :class="$style['currency-unit']">{{unit}}</span>
    </div>
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {},
    errorMessages: {
      type: Array
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    min: {
      type: Number
    },
    placeholder: {
      type: String
    },
    width: {
      type: String,
      default: "224"
    },
    rules: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: "円"
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    mergedErrorMessages() {
      // 価格変更の項目の場合
      if (this.name.match(/^items.+/)) {
        return [...this.errorMessages].join("<br>") || undefined;
      }

      return (
        [...this.vvErrors.collect(this.name), ...this.errorMessages].join(
          "<br>"
        ) || undefined
      );
    },
    mergedRules() {
      let rules = {};
      if (this.rules) {
        if (this.rules === "required") {
          rules = {
            required: true
          };
        }
      }
      return {
        regex: /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)$/,
        ...rules
      };
    },
    style() {
      let width = this.width;

      if (width) {
        width = this.width.match(/%/) ? `${this.width}` : `${this.width}px`;
      }

      return {
        width
      };
    }
  },
  methods: {
    createFormatter() {
      return new Intl.NumberFormat("ja-JP");
    },
    formatCurrency(value) {
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        !this.isNumeric(value)
      ) {
        return value;
      }
      return this.createFormatter().format(this.backToNumber(value));
    },
    backToNumber(value) {
      if (value) {
        return ("" + value).replace(/,/g, "");
      }
      return value;
    },
    isNumeric(value) {
      return Number.isInteger(+this.backToNumber(value));
    },
    focus(e){
      this.localValue = this.localValue == null ? '' : (String(this.localValue) || '').replace(/,/g, '');
    }
  },
  mounted(){
  }
};
</script>

<style module lang="scss">
.currency-field {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.currency-unit {
  margin-top: 4px;
  margin-left: 8px;
}
</style>

<style lang="scss">
.currency-text-field {
  .v-messages__message {
    font-size: 12px !important;
  }
}
</style>
